import { useState, useEffect } from 'react';

export function useUsers(supabase, user) {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    async function fetchUsers() {
      if (!supabase || !user?.org?.id) return;
      const { data: _users, error: usersError } = await supabase
        .from("memberships")
        .select("*, people(*)")
        .eq("org_id", user.org.id)
        .neq("status", "deleted")
        .order("firstname", { foreignTable: "people", ascending: true });
      
      if (usersError) {
        console.error("Error fetching users:", usersError);
        return;
      }
      
      const processedUsers = (_users || []).map((person) => ({
        id: person.people.id,
        firstname: person.people.firstname,
        lastname: person.people.lastname
      }));
      
      setUsers(processedUsers);
    }
    fetchUsers();
  }, [supabase, user]);

  return { users };
}

